import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107123Status: 'idle',
    startProcess107123Error: undefined as any,
    loadUserParamsProcess107123Status: 'idle',
    loadUserParamsProcess107123Error: undefined as any,

    process107123List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107123 = createAsyncThunk('process107123Slice/startProcess107123', async ({ process107123 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107123/`,
        prepareData(process107123),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107123Status } = getState().process107123Slice
        return startProcess107123Status !== 'pending'
    }
})

export const loadUserParamsProcess107123 = createAsyncThunk('process107123Slice/loadUserParamsProcess107123', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107123/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107123Status } = getState().process107123Slice
        return loadUserParamsProcess107123Status !== 'pending'
    }
})

const Process107123Slice = createSlice({
    name: 'process107123Slice',
    initialState,
    reducers: {
        resetstartProcess107123: (state) => {
            state.job = undefined
            state.startProcess107123Error = undefined
        },
        resetstartProcess107123Error: (state) => {
            state.startProcess107123Error = undefined
        },
        resetloadUserParamsProcess107123: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107123Error = undefined
        },
        resetloadUserParamsProcess107123Error: (state) => {
            state.loadUserParamsProcess107123Error = undefined
        },
        removeFromProcess107123ListById: (state, action) => {
            state.process107123List = state.process107123List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107123ListByIds: (state, action) => {
            state.process107123List = state.process107123List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107123List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107123Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107123List = []
            state.startProcess107123Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107123.pending, (state) => {
            state.startProcess107123Status = 'pending'
            state.startProcess107123Error = undefined
        })
        builder.addCase(startProcess107123.fulfilled, (state, action) => {
            state.startProcess107123Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107123.rejected, (state, action) => {
            state.startProcess107123Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107123Error = action.error.message
            } else {
                state.startProcess107123Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107123.pending, (state) => {
            state.loadUserParamsProcess107123Status = 'pending'
            state.loadUserParamsProcess107123Error = undefined
        })
        builder.addCase(loadUserParamsProcess107123.fulfilled, (state, action) => {
            state.loadUserParamsProcess107123Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107123.rejected, (state, action) => {
            state.loadUserParamsProcess107123Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107123Error = action.error.message
            } else {
                state.loadUserParamsProcess107123Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107123,
    resetstartProcess107123Error,
    resetloadUserParamsProcess107123,
    resetloadUserParamsProcess107123Error,
    removeFromProcess107123ListById,
    removeFromProcess107123ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107123Slice.actions
export default Process107123Slice.reducer
